var apiUrls = require('./api-urls');

// ICE failed, add a TURN server and see about:webrtc for more details
/*RTCIceServer.url is deprecated! Use urls instead.*/
var stuns = [
	{"urls": "stun:stun.l.google.com:19302"},
	{"urls": "stun:stun1.l.google.com:19302"},
	{"urls": "stun:stun2.l.google.com:19302"},
	{"urls": "stun:stun3.l.google.com:19302"},
	{"urls": "stun:stun4.l.google.com:19302"},
	{"urls": "stun:stun.ekiga.net"},
	{"urls": "stun:stun.ideasip.com"},
	{"urls": "stun:stun.schlund.de"},
	{"urls": "stun:stun.stunprotocol.org:3478"},
	{"urls": "stun:stun.voiparound.com"},
	{"urls": "stun:stun.voipbuster.com"},
	{"urls": "stun:stun.voipstunt.com"},
	{"urls": "stun:stun.voxgratia.org"},
	{"urls": "stun:stun.services.mozilla.com"}
], randomize = function () {
  return this.splice(Math.floor(Math.random()*this.length-1), 1)[0];
};

var env = {
	PUSHER_ID: '4a47a964fe64785e8ff8',
	API_URLS: apiUrls,
	RTC_SIGNAL_HOST: 'https://ss.brandedbridgeline.com/rtcsw/',
	SLIDESHARE_SIGNAL_HOST: 'https://ss.brandedbridgeline.com',
  UPLOAD_SIZE_LIMIT: 120 * 1024 * 1024, //120MB
  SENTRY_DSN: 'https://64a6d0cae1f84d90bd044e08a01bb752@app.getsentry.com/58052',

	ICE_SERVERS: [
    { urls: ["stun:35.192.167.125:3478"] },
    { urls: ["turn:35.192.167.125:3478?transport=udp"], username:"1001", credential:"1234callers" },
		// {"urls": "stun:stun.l.google.com:19302"},
		// {
		// 	"urls": ["turn:ss.brandedbridgeline.com:3478?transport=udp"],
		// 	"credential": "notyorregularpassword",
		// 	"username": "bblturnadmin"
		// }
	],

  googleClientId: '146102134890-a0q92k52ink671s4a63599km5k2iah02.apps.googleusercontent.com',

  SKIP_VERIFICATION_INTERVAL: [
    7, 23,
  ],

  SKIP_VERIFICATION_CODE: [
    '7777',
  ],

	dev: {
		isProd: false,
		INTERCOM_ID: 't3fh2ns8',


		FREESWITCH: {
			wss: 'fsbeta.bblapp.io:7443',
			realm: 'fsbeta.bblapp.io',

			username: '1001',
			password: '1234callers',
		},
	},

	prod: {
		isProd: true,
		INTERCOM_ID: 'z33w58p7',

		FREESWITCH: {
			wss: 'fs10v5.bblapp.io:7443',
			realm: 'fs10v5.bblapp.io',

			username: '1001',
			password: '1234callers',
		},
	}
}, isProd = process.env.ENV === 'production';

module.exports = angular.extend({}, env, env[isProd ? 'prod' : 'dev']);



/*****************
 ** WEBPACK FOOTER
 ** ./config/environment.js
 ** module id = 76
 ** module chunks = 0
 **/